<template>
    <div ref="root">
        <div
            class="team__container module__container"
            v-bind:class="{ container__fluid: [1, 2, 3].includes(module.layout.type) }"
        >
            <div class="team__inner module__inner">
                <div class="team__inner--main module__inner--main">
                    <div
                        class="team__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle || module.data.text"
                    >
                        <div class="team__inner-col module__inner-col">
                            <div
                                class="team__header module__header bg-color"
                                v-bind:class="{
                                    'module--color-1': [1].includes(
                                        parseInt(module.appearance.color)
                                    ),
                                    'module--color-2': [2].includes(
                                        parseInt(module.appearance.color)
                                    ),
                                    'module--color-3': [3].includes(
                                        parseInt(module.appearance.color)
                                    ),
                                    'module--color-4': [4].includes(
                                        parseInt(module.appearance.color)
                                    ),
                                    'module--color-5': [5].includes(
                                        parseInt(module.appearance.color)
                                    ),
                                    'module--color-6': [6].includes(
                                        parseInt(module.appearance.color)
                                    ),
                                    'module--color-7': [7].includes(
                                        parseInt(module.appearance.color)
                                    )
                                }"
                            >
                                <app-modulebackground
                                    :module-id="module.id"
                                    custom-class="team__background module__background"
                                ></app-modulebackground>
                                <h2
                                    class="team__title module__title font-h2 color-h2"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="team__subtitle module__subtitle font-h3 color-h3"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                                <div
                                    class="team__text module__text font-p color-p module__cms"
                                    v-bind:class="{
                                        container__boxed: [1, 2, 3].includes(module.layout.type)
                                    }"
                                    v-if="module.data.text"
                                    v-html="module.data.text"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="team__inner-row module__inner-row bg-color"
                        v-if="items && Array.isArray(items) && items.length > 0"
                        v-bind:class="{
                            'module--color-1':
                                [1, 3].includes(parseInt(getActiveTheme)) &&
                                [2, 3].includes(module.layout.type) &&
                                [2, 3, 4, 5, 6, 7].includes(parseInt(module.appearance.color)),
                            'module--color-2':
                                [1, 3].includes(parseInt(getActiveTheme)) &&
                                [2, 3].includes(module.layout.type) &&
                                [1].includes(parseInt(module.appearance.color)),
                            'module--color-3':
                                [4].includes(parseInt(getActiveTheme)) &&
                                [2, 3].includes(module.layout.type) &&
                                [1, 2, 4, 5, 6, 7].includes(parseInt(module.appearance.color)),
                            'module--color-4':
                                [4].includes(parseInt(getActiveTheme)) &&
                                [2, 3].includes(module.layout.type) &&
                                [3].includes(parseInt(module.appearance.color)),
                            'module--color-6':
                                [2].includes(parseInt(getActiveTheme)) &&
                                [2, 3].includes(module.layout.type) &&
                                [7].includes(parseInt(module.appearance.color)),
                            'module--color-7':
                                [2].includes(parseInt(getActiveTheme)) &&
                                [2, 3].includes(module.layout.type) &&
                                [1, 2, 3, 4, 5, 6].includes(parseInt(module.appearance.color))
                        }"
                    >
                        <div
                            class="team__inner-col module__inner-col"
                            v-bind:class="{
                                container__boxed: [2].includes(module.layout.type)
                            }"
                        >
                            <div
                                class="team__list module__list"
                                v-bind:class="{ 'flex--wrap': [2, 3].includes(module.layout.type) }"
                            >
                                <div
                                    :data-id="items__value.id"
                                    v-for="(items__value, items__key) in items"
                                    v-bind:key="items__value.id"
                                    :data-preset-id="items__value.preset_id"
                                    class="team__list-item module__list-item bg-color"
                                    :class="[
                                        {
                                            'module--color-1':
                                                [1].includes(module.layout.type) &&
                                                ((items__key % 2 !== 0 &&
                                                    [1].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                    (items__key % 2 === 0 &&
                                                        [1, 3].includes(parseInt(getActiveTheme)) &&
                                                        [2, 3, 4, 5, 6, 7].includes(
                                                            parseInt(module.appearance.color)
                                                        ))),
                                            'module--color-2':
                                                [1].includes(module.layout.type) &&
                                                ((items__key % 2 !== 0 &&
                                                    [2].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                    (items__key % 2 === 0 &&
                                                        [1, 3].includes(parseInt(getActiveTheme)) &&
                                                        [1].includes(
                                                            parseInt(module.appearance.color)
                                                        ))),
                                            'module--color-3':
                                                [1].includes(module.layout.type) &&
                                                ((items__key % 2 !== 0 &&
                                                    [3].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                    (items__key % 2 === 0 &&
                                                        [4].includes(parseInt(getActiveTheme)) &&
                                                        [1, 2, 4, 5, 6, 7].includes(
                                                            parseInt(module.appearance.color)
                                                        ))),
                                            'module--color-4':
                                                [1].includes(module.layout.type) &&
                                                ((items__key % 2 !== 0 &&
                                                    [4].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                    (items__key % 2 === 0 &&
                                                        [4].includes(parseInt(getActiveTheme)) &&
                                                        [3].includes(
                                                            parseInt(module.appearance.color)
                                                        ))),
                                            'module--color-5':
                                                [1].includes(module.layout.type) &&
                                                items__key % 2 !== 0 &&
                                                [5].includes(parseInt(module.appearance.color)),
                                            'module--color-6':
                                                [1].includes(module.layout.type) &&
                                                ((items__key % 2 !== 0 &&
                                                    [6].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                    (items__key % 2 === 0 &&
                                                        [2].includes(parseInt(getActiveTheme)) &&
                                                        [1, 2, 3, 4, 5, 7].includes(
                                                            parseInt(module.appearance.color)
                                                        ))),
                                            'module--color-7':
                                                [1].includes(module.layout.type) &&
                                                ((items__key % 2 !== 0 &&
                                                    [7].includes(
                                                        parseInt(module.appearance.color)
                                                    )) ||
                                                    (items__key % 2 === 0 &&
                                                        [2].includes(parseInt(getActiveTheme)) &&
                                                        [6].includes(
                                                            parseInt(module.appearance.color)
                                                        )))
                                        }
                                    ]"
                                >
                                    <app-configbar
                                        v-if="editorMode"
                                        :show-data="true"
                                        :show-layout="false"
                                        :show-appearance="false"
                                        v-on:open="
                                            directEditListeditor({
                                                dataSource: 'deha.user.misc.team',
                                                listSubpage: 'Team',
                                                module_id: module.id,
                                                listitem_id: items__value.id
                                            })
                                        "
                                        inner
                                    ></app-configbar>

                                    <div
                                        v-if="items__value.data"
                                        class="team__list-details"
                                        v-bind:class="{
                                            'container__boxed flex--wrap': [1, 3].includes(
                                                module.layout.type
                                            ),
                                            'flex--wrap border-color-highlighted': [2].includes(
                                                module.layout.type
                                            )
                                        }"
                                    >
                                        <div
                                            class="team__list-details--left"
                                            v-bind:class="{
                                                'col__width--full flex--wrap': [3].includes(
                                                    module.layout.type
                                                ),
                                                'col__width--half': [1].includes(module.layout.type)
                                            }"
                                        >
                                            <div
                                                class="team__list-details--col"
                                                v-bind:class="{
                                                    'col__width--half': [3].includes(
                                                        module.layout.type
                                                    )
                                                }"
                                            >
                                                <h3
                                                    v-if="items__value.data.name"
                                                    class="team__list-details--name font-bold font-h3 color-h3"
                                                >
                                                    {{ items__value.data.name }}
                                                </h3>
                                                <div
                                                    class="team__list-details--position-location color-p"
                                                >
                                                    <div
                                                        v-if="items__value.data.position"
                                                        class="team__list-details--position team__list-details--subitem font-bold border-color"
                                                    >
                                                        {{ items__value.data.position }}
                                                    </div>
                                                    <div
                                                        v-if="items__value.data.location"
                                                        class="team__list-details--location team__list-details--subitem font-bold border-color"
                                                    >
                                                        {{ items__value.data.location }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="team__list-details--col color-p"
                                                v-bind:class="{
                                                    'col__width--half': [3].includes(
                                                        module.layout.type
                                                    )
                                                }"
                                            >
                                                <div
                                                    v-if="items__value.data.phone"
                                                    class="team__list-details--phone"
                                                >
                                                    Telefon:
                                                    <a
                                                        v-bind:href="
                                                            'tel:' + items__value.data.phone
                                                        "
                                                        class="module__link--underlined"
                                                        >{{ items__value.data.phone }}</a
                                                    >
                                                </div>
                                                <div
                                                    v-if="items__value.data.email"
                                                    class="team__list-details--mail"
                                                >
                                                    E-Mail:
                                                    <a
                                                        v-bind:href="
                                                            'mailto:' + items__value.data.email
                                                        "
                                                        class="module__link--underlined"
                                                        >{{ items__value.data.email }}</a
                                                    >
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            class="team__list-details--right"
                                            v-bind:class="{
                                                'col__width--full': [3].includes(
                                                    module.layout.type
                                                ),
                                                'col__width--half': [1].includes(module.layout.type)
                                            }"
                                        >
                                            <app-moduleimage
                                                v-if="[1, 2].includes(module.layout.type)"
                                                :data="items__value.data.image"
                                                :tag="'div'"
                                                :custom-class="
                                                    'team__list-item-image image-container--contain'
                                                "
                                            ></app-moduleimage>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="team__inner-row" v-if="module.data.link && module.data.link.active">
                        <div class="team__inner-col module__inner-col">
                            <div class="team__cta module__cta">
                                <app-modulebutton
                                    :data="module.data.link"
                                    :custom-class="
                                        'team__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import Configbar from '@/components/assorted/Configbar.vue';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleimage': ModuleImage,
        'app-modulebackground': ModuleBackground,
        'app-configbar': Configbar
    },
    methods: {
        ...mapActions(['directEditListeditor'])
    },
    computed: {
        ...mapGetters(['getListItems', 'editorMode', 'getActiveTheme']),
        items() {
            return this.getListItems('deha.user.misc.team');
        }
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
